module.exports = __webpack_public_path__ + "static/media/other-optioned-building.ae289ef7.svg";